import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.structured-clone.js";
import { __decorate } from "tslib";
import { Component, Emit, Prop, Vue, Watch } from "vue-facing-decorator";
import WInput from "@/components/form/w-input.vue";
import { BlankResponseType, BlankType } from "@/models/blanksInput.model";
import StandardButton from "@/components/buttons/StandardButton.vue";
import WDialog from "@/components/wrappers/w-dialog.vue";
import QuestionAnswerImageUploader from "@/components/questions/QuestionAnswerImageUploader.vue";
import QuizUtils from "@/util/quizUtils";
import quizUtils from "@/util/quizUtils";
let BlankAsDropdownSettingsDialog = class BlankAsDropdownSettingsDialog extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "blank", void 0);
    _defineProperty(this, "visible", void 0);
    _defineProperty(this, "highlightRequiredFields", false);
    _defineProperty(this, "realtimeBlankData", null);
    _defineProperty(this, "isVisible", true);
  }
  areAllBlankSetted() {
    return this.realtimeBlankData !== null && this.realtimeBlankData.responses.every(blankAnswer => !!blankAnswer.label?.trim() || QuizUtils.questionAnswerImageExists(blankAnswer.image));
  }
  mounted() {
    this.isVisible = this.visible;
    this.initRealtimeBlankData();
  }
  get LABEL_NB_MAX_CHARS() {
    return quizUtils.QUIZ_LABELS_NB_MAX_CHARS;
  }
  shouldDisplayError(answer) {
    return !answer.label?.trim() && !QuizUtils.questionAnswerImageExists(answer.image) && this.highlightRequiredFields;
  }
  initRealtimeBlankData() {
    if (this.blank) {
      this.realtimeBlankData = structuredClone(this.blank);
    } else {
      this.realtimeBlankData = {
        position: -1,
        type: BlankType.MULTI_SELECT,
        responses: []
      };
    }
  }
  onVisibilityPropChanges() {
    this.isVisible = this.visible;
  }
  onBlankAnswerOptionUpdate(answer, label) {
    if (!answer.image) {
      answer.label = label.trim();
    } else {
      answer.image.imageLabel = label.trim();
      answer.label = undefined;
    }
  }
  onBlankCorrectAnswerUpdate(answer) {
    if (this.realtimeBlankData?.responses?.length) {
      this.realtimeBlankData.responses.forEach(blankAnswer => blankAnswer.correctAnswer = blankAnswer === answer);
    }
  }
  onBlankAnswerDelete(answerToDel) {
    if (this.realtimeBlankData?.responses?.length) {
      const shouldReassignCorrectAnswer = answerToDel.correctAnswer && this.realtimeBlankData.responses.length > 1;
      this.realtimeBlankData.responses = this.realtimeBlankData.responses.filter(answer => answer !== answerToDel);
      if (shouldReassignCorrectAnswer) {
        this.realtimeBlankData.responses[0].correctAnswer = true;
      }
    }
  }
  addBlankAnswer() {
    if (this.realtimeBlankData) {
      this.realtimeBlankData.responses.push({
        label: '',
        type: BlankResponseType.MULTI_SELECT_OPTION,
        correctAnswer: this.realtimeBlankData.responses.length === 0,
        caseSensitive: false
      });
    }
  }
  cancelSettingsEdit() {
    this.closeDialog();
  }
  validateSettings() {
    if (this.areAllBlankSetted()) {
      this.isVisible = false;
      return this.$emit('blankAsDropdownSettingsUpdate', this.realtimeBlankData);
    } else {
      this.highlightRequiredFields = true;
    }
  }
  onAnswerImageChange(uploadedImage, blankResponse) {
    blankResponse.image = {
      imageName: uploadedImage.originalName,
      imageLabel: blankResponse.label,
      uploadTmpPath: uploadedImage.path
    };
    blankResponse.label = undefined;
  }
  onImageDelete(blankResponse) {
    blankResponse.label = blankResponse.image?.imageLabel;
    blankResponse.image = undefined;
  }
  closeDialog() {
    this.isVisible = false;
    this.realtimeBlankData = null;
    return this.isVisible;
  }
};
__decorate([Prop({
  default: null
})], BlankAsDropdownSettingsDialog.prototype, "blank", void 0);
__decorate([Prop({
  required: true
})], BlankAsDropdownSettingsDialog.prototype, "visible", void 0);
__decorate([Watch('visible')], BlankAsDropdownSettingsDialog.prototype, "onVisibilityPropChanges", null);
__decorate([Emit("dialog-close")], BlankAsDropdownSettingsDialog.prototype, "closeDialog", null);
BlankAsDropdownSettingsDialog = __decorate([Component({
  components: {
    QuestionAnswerImageUploader,
    WDialog,
    StandardButton,
    WInput
  },
  emits: ['blankAsDropdownSettingsUpdate']
})], BlankAsDropdownSettingsDialog);
export default BlankAsDropdownSettingsDialog;